import React from 'react';

const Header = ({ currentUser, onMenuToggle, activeTab }) => {
  const getPageTitle = () => {
    const titles = {
      dashboard: 'Dashboard',
      addMatch: 'Match Entry Logs',
      players: 'Squad Overview',
      goalkeeper: 'GK Analytics',
      teamgen: 'Team Builder',
      settings: 'Global Settings'
    };
    return titles[activeTab] || 'Dashboard';
  };

  return (
    <header className="sticky top-0 z-30 bg-background/80 backdrop-blur-xl border-b border-outline-variant/30 px-4 py-4 transition-all lg:pl-[272px]">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        
        {/* Left: Mobile Menu + Title */}
        <div className="flex items-center gap-4">
          <button
            onClick={onMenuToggle}
            className="lg:hidden p-2 text-stone-600 hover:text-on-background hover:bg-surface-container-high rounded-xl transition-all active:scale-95"
          >
            <span className="material-symbols-outlined">menu</span>
          </button>
          
          <div>
            <h2 className="text-xl md:text-2xl font-black font-lexend text-on-background tracking-tight">
              {getPageTitle()}
            </h2>
            <p className="hidden md:flex items-center gap-1.5 font-manrope text-xs text-stone-600 mt-1">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-error opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-error"></span>
              </span>
              Live Data Feed
            </p>
          </div>
        </div>

        {/* Right: User Profile */}
        <div className="flex items-center gap-3">
          <div className="hidden sm:block text-right">
            <p className="text-on-background font-bold font-manrope text-sm">{currentUser?.username || 'Guest'}</p>
            <p className="text-primary text-[10px] font-bold uppercase tracking-widest">{currentUser?.role || 'Viewer'}</p>
          </div>
          <div className="w-10 h-10 bg-surface-container-high border border-outline-variant/50 rounded-full flex items-center justify-center shadow-lg cursor-pointer hover:border-primary/50 transition-colors">
            <span className="material-symbols-outlined text-primary text-[20px]">person</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
